// 客户费率模板

import { HttpInboundBillClientList, HttpSubmitInboundBill,HttpBatchSubmitInboundBill,HttpRemarkInboundBill, HttpCancelInboundBill, HttpExportInboundBill, HttpCopyInboundPlanOrder, HttpRevokeAudit, HttpDownCarton, HttpCreateBatchPackageLabel,HttpReprocessError,HttpIgnoreInboundError, HttpGetInbopundSpan, HttpGetAreaList } from '@/service/inbound';
import TableList from "@components/templates/tablelist";

// import compSeelogistics from '../../headlogistics/seelogistics'
import compSeelogistics from '../../headlogistics/newSeelogistics'
import comIndex from './update'
import modifyDate from './modifydate'

import { mapGetters } from 'vuex';
import mixin from '../mixin';

import compDelivergood from './delivergood';
import compAppointorder from './appointorder';
import compUpload from "@components/templates/selectupload";
export default {
    mixins: [TableList, mixin],
    components:{
        compSeelogistics,
        comIndex,
        compDelivergood,
        compAppointorder,
        compUpload,
        modifyDate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                isManage: false,
                search: {
                    'quanbu': 0,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            spanTabs: { show: true },
            areaList: []
        };
    },
    created(){
        // 添加权限
        this.perUpdate = this.handleAuth('fbb.inboundplan.update');
        this.getAreaList();
        // console.log(this.perUpdate)

    },
    methods: {
        async getAreaList () {
            await HttpGetAreaList().then(res => {
                this.areaList = res.data.map(item => {
                    return {
                        label: item.areaName,
                        value: item.id
                    }
                });
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        ajaxRequest: HttpInboundBillClientList,
        spanAjaxRequest: HttpGetInbopundSpan,
        handleParams(params) {
            // console.log(params);

            if (params.search.quanbu === 0) {
                params.search.EQ_inboundPlanOrderStatus = null;
            }
            else if (params.search.shenhe === 0) {
                params.search.EQ_inboundPlanOrderStatus = 5
            }
            else if (params.search.juhui === 0) {
                params.search.EQ_inboundPlanOrderStatus = 6
            }
            else if (params.search.unpacked === 0) {
                params.search.EQ_inboundPlanOrderStatus = 8
            }
            else if (params.search.unship === 0) {
                params.search.EQ_inboundPlanOrderStatus = 10;
            }
            else if (params.search.shipped === 0) {
                params.search.EQ_inboundPlanOrderStatus = 20;
            }
            else if (params.search.inthe_library === 0) {
                params.search.EQ_inboundPlanOrderStatus = 25;
            }else if (params.search.finished === 0) {
                params.search.EQ_inboundPlanOrderStatus = 70;
            }else if (params.search.error_order === 0) {
                params.search.NE_errorStatus = 99999;
            }

            delete params.search.quanbu
            delete params.search.shenhe
            delete params.search.juhui
            delete params.search.unpacked
            delete params.search.unship
            delete params.search.shipped
            delete params.search.inthe_library
            delete params.search.finished
            delete params.search.error_order

            return params
        },
        interceptRequest(params){
            // console.log(params)
            const { warehouseType,CN_cartonNo,sku,CN_inboundPlanOrderNo } = params.search;
            let IN_inboundPlanOrderNo,cartonNo,arr1,arr2=[],arr3,arr4=[];
            if(CN_inboundPlanOrderNo){
                arr1 = CN_inboundPlanOrderNo.split(/\n/);
                arr1.map(item=>{
                    if(item){
                        arr2.push(item)
                    }
                })
                if(arr2.length>0){
                    IN_inboundPlanOrderNo = arr2.toString()
                }

            }
            if(CN_cartonNo){
                arr3 = CN_cartonNo.split(/\n/);
                arr3.map(item=>{
                    if(item){
                        arr4.push(item)
                    }
                })
                if(arr4.length>0){
                    cartonNo = arr4.toString()
                }
            }

            params.warehouseType = warehouseType;
            params.cartonNo = cartonNo;
            params.sku = sku;
            params.search.IN_inboundPlanOrderNo = IN_inboundPlanOrderNo;

            delete params.search.warehouseType;
            delete params.search.CN_cartonNo;
            delete params.search.sku;
            delete params.search.CN_inboundPlanOrderNo;
            // this.formData = params;
            return this.handleParams(params)
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'add':
                    this.$router.push({
                        name: "inboundBillclientDetail",
                        params: { type },
                    })
                    break;
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false,
                        alertbox:'alertbox'
                    }
                    break;
                case 'queryBlank':
                    window.open(this.$router.resolve({
                        name: "inboundBillclientDetail",
                        params: { type:'query' },
                        query: { id: params },
                    }).href, '_blank');
                    break;
                case 'edit':
                    window.open(this.$router.resolve({
                        name: "inboundBillclientDetail",
                        params: { type },
                        query: { id: params },
                    }).href, '_blank');
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.cancel', { defaultValue: '取消' }),
                        width: 'middle',
                        showDesc: false,
                        params: { id: params },
                        ajaxRequest: HttpCancelInboundBill,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: this.$t('fbb.inbound.cancel_reason', { defaultValue: '取消原因' })
                            }
                        ]
                    };
                    break;
                case "addRemark":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('fbb.inbound.add_remark', { defaultValue: '添加备注' }),
                        width: 'middle',
                        showDesc: false,
                        params: { id: params },
                        ajaxRequest: HttpRemarkInboundBill,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" })
                            }
                        ]
                    };
                    break;
                case "submit":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: this.$t('global.common.update_submit', { defaultValue: '提交' }),
                        params: { id: params },
                        ajaxRequest: HttpSubmitInboundBill,
                    };
                    break;
                case "batchSubmit":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: this.$t('global.common.update_submit', { defaultValue: '提交' }),
                        params: { ids: params },
                        ajaxRequest: HttpBatchSubmitInboundBill,
                    };
                    break;
                case "errorReprocess":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: this.$t('global.common.error_process', { defaultValue: '异常重处理' }),
                        params: { id: params },
                        ajaxRequest: HttpReprocessError,
                    };
                    break;
                case "errorIgnore":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: this.$t('global.common.error_ignore', { defaultValue: '忽略异常' }),
                        params: { id: params },
                        ajaxRequest: HttpIgnoreInboundError,
                    };
                    break;
                case "copyorder":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('fbb.inbound.copy_order', { defaultValue: '单据复制' }),
                        params: { id: params },
                        ajaxRequest: HttpCopyInboundPlanOrder,
                    };
                    break;
                case "rebackaudit":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('fbb.inbound.cancel_audit', { defaultValue: '撤销审核' }),
                        params: { id: params },
                        ajaxRequest: HttpRevokeAudit,
                    };
                    break;
                case 'export':
                    this.handleWebfs(HttpExportInboundBill, this.interceptRequest(JSON.parse(JSON.stringify(this.formData))), { executor: 'request', download: true });
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: '导入数据',
                        width: 460,
                        showFooter: false,
                        actionurl: process.env.VUE_APP_APIURL_FBB+ "/api/v2/Inbound/importOrder",
                        name: "multipartFile",
                        component: "compUpload",
                        // download: () => {
                        //     this.handleWebfs(process.env.VUE_APP_APIURL_FBB+"/static/template/import_product.xlsx", {}, {
						// 		executor: 'download',
						// 		type: 'url'
						// 	});
                        // },
                        downrul:'/static/template/import_product.xlsx',
                        on:{
                            "on-success":()=>{
                                this.$emit('on-close')
                            }
                        }
                    };
                    break;
                case 'seelogistics':
                    this.operate = {
                        title: this.$t('fbb.inbound.view_logistics', { defaultValue: '物流查看' }),
                        show:true,
                        width:1200,
                        component: "compSeelogistics",
                        orderid:params,
                        querytype:'query',
                        boxtype:'inbound',
                        showFooter:false
                    };
                    break;
                case 'createlogistics':
                    this.$router.push({
                        name: 'createheadlogistics',
                        params: { type: "add",jump:'inbound' },
                    });
                    break;
                case 'changeship':
                    this.operate = {
                        title: this.$t('fbb.inbound.modify_shipping_information', { defaultValue: '修改发运信息' }),
                        show:true,
                        width:1200,
                        component: "compDelivergood",
                        orderid:params,
                        isEdit:true,
                        activeid:params,
                        changetype:'inbound',
                        showFooter:false
                    };
                    break;
                case 'seeyuyue':
                    this.operate = {
                        title: this.$t('fbb.inbound.view_appointment_form', { defaultValue: '查看预约单' }),
                        show:true,
                        width:1200,
                        component: "compAppointorder",
                        activeid:params,
                        showFooter:false
                    };
                    break;
                case 'allprodcarton':
                    // this.handleWebfs(HttpCreateBatchPackageLabel, {ids:params}, { executor: 'request', download: true });
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: this.$t('fbb.inbound.generation_box_label', { defaultValue: '批量生成箱标' }),
                        params: { ids: params },
                        formdata:[
                            {
                                tag: 'vRadio',
                                key: 'pageSize',
                                labelWidth: 'auto',
                                default: '6',
                                span: 24,
                                label: this.$t('fbb.inbound.number_page', { defaultValue: '每页个数' }),
                                options: [{
                                    trueValue: '6',
                                    label: this.$t('fbb.inbound.each_page', { pagevalue: '6', defaultValue: '每页6个' }),
                                }, {
                                    trueValue: '1',
                                    label: this.$t('fbb.inbound.each_page', { pagevalue: '1', defaultValue: '每页1个' }),
                                }]
                            },
                            {
                                tag: 'vRadio',
                                key: 'type',
                                labelWidth: 'auto',
                                default: '1',
                                span: 24,
                                label: this.$t('fbb.inbound.copies', { defaultValue: '份数' }),
                                options: [{
                                    trueValue: '1',
                                    label: this.$t('fbb.inbound.cope_one', { defaultValue: '一式一份' }),
                                }, {
                                    trueValue: '2',
                                    label: this.$t('fbb.inbound.cope_two', { defaultValue: '一式两份' }),
                                }]

                            },
                            {
                                tag: 'vCheckbox',
                                key: 'isIndexNo',
                                labelWidth: 'auto',
                                required:false,
                                default: '0',
                                span: 24,
                                label: this.$t('fbb.inbound.digital', { defaultValue: '是否生成序号' }),
                                props: {
                                    trueValue: 1,
                                    falseValue: 0,
                                    strict: false,
                                }
                            }
                        ],
                        ajaxRequest: HttpCreateBatchPackageLabel,
                    };
                    break;
                case 'alldowncarton':
                    this.handleWebfs(HttpDownCarton, {ids:params}, { executor: 'request', download: true });
                    break;
                case 'importFirm':
                    {
                        this.operate = {
                            show: true,
                            title: this.$t('fbb.inbound.import_firm', { defaultValue: "导入Firm" }),
                            width: 460,
                            showFooter: false,
                            name: "multipartFile",
                            component: "compUpload",
                            localurl:true,
                            actionurl:process.env.VUE_APP_APIURL_FBB+'/api/v2/Inbound/importUpdateFirm',
                            downrul:'/static/template/importFirm.xlsx',
                        };
                    }
                    break;
                case "modifyDate":
                    this.operate = {
                        title: this.$t('fbb.inbound.modify_date', { defaultValue: '修改日期' }),
                        show:true,
                        width:600,
                        component: "modifyDate",
                        inboundPlanOrderId:params,
                        querytype:'query',
                        showFooter:false,
                        alertbox:'alertbox'
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, inboundPlanOrderStatus, sourceSystem, inboundPlanOrderNo, errorStatus } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show: (inboundPlanOrderStatus == 6 || inboundPlanOrderStatus == 0) && this.perUpdate,
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('global.common.update_submit', { defaultValue: '提交' }),
                show: (inboundPlanOrderStatus == 6 || inboundPlanOrderStatus == 0) && this.perUpdate,
                params: id,
                operate: 'submit'
            }, {
                label: this.$t('global.common.cancel', { defaultValue: '取消' }),
                show: inboundPlanOrderStatus != 25 && inboundPlanOrderStatus != 70 && inboundPlanOrderStatus != 100 && this.perUpdate,
                params: id,
                operate: 'cancel'
            },
            {
                label: this.$t('fbb.inbound.cancel_audit', { defaultValue: '撤销审核' }),
                show: inboundPlanOrderStatus == 5 && this.perUpdate,
                params: id,
                operate: 'rebackaudit'
            },
            {
                label: this.$t('fbb.inbound.copy_order', { defaultValue: '单据复制' }),
                show: this.perUpdate,
                params: id,
                operate: 'copyorder'
            },
            {
                label: this.$t('fbb.inbound.seelogistics', { defaultValue: '查看物流' }),
                show: true,
                params: inboundPlanOrderNo,
                operate: 'seelogistics'
            },
            {
                label: this.$t('fbb.inbound.modify_shipping_information', { defaultValue: '修改发运信息' }),
                show: inboundPlanOrderStatus == 20,
                params: id,
                operate: 'changeship'
            },{
                label: this.$t('fbb.inbound.check_appointment', { defaultValue: '查看预约情况' }),
                show: inboundPlanOrderStatus == 20 || inboundPlanOrderStatus == 25 || inboundPlanOrderStatus == 70,
                params: inboundPlanOrderNo,
                operate: 'seeyuyue'
            },
                {
                    label: this.$t('global.common.reprocess', { defaultValue: '重处理' }),
                    show: errorStatus != 99999,
                    params: id,
                    operate: 'errorReprocess'
                },
                {
                    label: this.$t('global.common.ignoreError', { defaultValue: '忽略异常' }),
                    show: errorStatus != 99999,
                    params: id,
                    operate: 'errorIgnore'
                },
                {
                    label: this.$t('fbb.inbound.add_remark', { defaultValue: '添加备注' }),
                    show: true,
                    params: id,
                    operate: 'addRemark'
                },
                {
                    label: this.$t('fbb.inbound.modify_date', { defaultValue: '修改日期' }),
                    show: inboundPlanOrderStatus==8 || inboundPlanOrderStatus==10, //待装箱 8;待发货 10
                    params: id,
                    operate: 'modifyDate'
                },]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getOrgList', 'getProductList', 'getFilterDisabledWarehouse']),
        TabsData() {
            return [
                {
                    name: this.$t('global.common.all', { defaultValue: "全部" }),
                    key: 'quanbu',
                    val: 0,
                    spanKey: 'allQty',
                },
                {
                    name: this.$t('fbb.inbound.check_pending', { defaultValue: "待审核" }),
                    key: 'shenhe',
                    val: 0,
                    spanKey: 'unApprovedQty',
                }, {
                    name: this.$t('fbb.inbound.approval_back', { defaultValue: "审批拒回" }),
                    key: "juhui",
                    val: 0,
                    spanKey: 'refusedQty',
                },{
                    name: this.$t('fbb.inbound.for_packing', { defaultValue: "待装箱" }),
                    key: "unpacked",
                    val: 0,
                    spanKey: 'unPackedQty',
                }, {
                    name: this.$t('fbb.inbound.send_goods', { defaultValue: "待发货" }),
                    key: "unship",
                    val: 0,
                    spanKey: 'unShippedQty',
                }, {
                    name: this.$t('fbb.inbound.stock_pending', { defaultValue: "待入库" }),
                    key: "shipped",
                    val: 0,
                    spanKey: 'unReceivedQty',
                },
                {
                    name: this.$t('fbb.inbound.inthe_library', { defaultValue: '入库中' }),
                    key: 'inthe_library',
                    val: 0,
                    spanKey: 'inboundQty',
                },
                {
                    name: this.$t('global.common.finished', { defaultValue: "已完成" }),
                    key: "finished",
                    val: 0,
                    spanKey: 'completedQty',
                },
                {
                    name: this.$t('fbb.order.error_order', { defaultValue: "异常单" }),
                    key: "error_order",
                    val: 0,
                    spanKey: 'errorQty',
                },
            ]
        },
        ToolsData() {
            return [{
                name: this.$t('global.common.add', { defaultValue: '添加' }),
                operate: "add",
                theme: "primary",
            }, {
                name: this.$t('global.common.export', { defaultValue: '导出' }),
                operate: "export",
                show: this.handleAuth('fbb.inboundplan.export')
            },{
                name: this.$t('global.common.import', { defaultValue: '导入' }),
                operate: "import",
                more:true,
            },{
                name: this.$t('fbb.alloment.muti_commit', { defaultValue: '批量提交' }),
                operate: "batchSubmit",
                more:true,
                batch:true,
            },{
                name: this.$t('fbb.inbound.headlogistics', { defaultValue: '创建头程物流单' }),
                operate: "createlogistics",
                more:true,
            },{
                name: this.$t('fbb.inbound.generation_box_label', { defaultValue: '批量生成箱标' }),
                operate: "allprodcarton",
                more:true,
                batch:true,
            },{
                name: this.$t('fbb.inbound.download_box_label', { defaultValue: '批量下载箱标' }),
                operate: "alldowncarton",
                more:true,
                batch:true,
            }, {
                name: this.$t('fbb.inbound.import_firm', { defaultValue: "导入Firm" }),
                operate: "importFirm",
                show: this.handleAuth('fbb.inboundorder.firm'),
                more: true
            }]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.inbound.storage_number', { defaultValue: '入库计划单号' }),
                    key: 'CN_inboundPlanOrderNo',
                    show: true,
                    tag: 'vTextarea',
                    class:"inboundtext",
                    props:{
                        placeholder: this.$t('fbb.inbound.input_more_line', { defaultValue: "输入多个，一行一个" }),
                        rows:"1",
                    }
                },
                {
                    label: this.$t('global.common.source_number', { defaultValue: '来源单号' }),
                    key: 'CN_sourceNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'EQ_orgWarehouseId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getFilterDisabledWarehouse,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: 'IN_lineId',
                    tag: 'vSelect',
                    options: this.getProductList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                },
                {
                    label: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'IN_inboundPlanOrderStatus',
                    tag: 'vSelect',
                    options: this.getBillStatus,
                    props:{
                        multiple:true
                    }
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    key: 'EQ_inventoryType',
                    tag: 'vSelect',
                    options: this.getInventoryType,
                },
                {
                    label: "Shipment ID",
                    key: 'EQ_shipmentId',
                    tag: 'vInput',
                },
                {
                    label: "Reference ID",
                    key: 'EQ_referenceId',
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inbound.errorcode', { defaultValue: "异常类型" }),
                    tag: 'vSelect',
                    key: 'EQ_errorStatus',
                    options: this.getAbnormalType,
                    show: true,
                },
                {
                    label: this.$t('fbb.inbound.purchase_order_no', { defaultValue: "采购单号" }),
                    key: 'CN_poNos',
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inbound.warehouse_type', { defaultValue: "仓库类型" }),
                    key: 'warehouseType',
                    tag: 'vSelect',
                    options:[
                        {value:1,label: this.$t('fbb.inbound.third_party_warehouse', { defaultValue: '三方仓' })},
                        {value:2,label: this.$t('fbb.inbound.amazon_warehouse', { defaultValue: '亚马逊仓' })},
                        {value:3,label: this.$t('fbb.inbound.self_operated_warehouse', { defaultValue: '自营仓' })},
                    ],
                },
                {
                    label: this.$t('fbb.inbound.batch_number_query', { defaultValue: "批次号查询" }),
                    key: 'CN_batchNumber',
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inbound.logistics_singleno', { defaultValue: "物流单号" }),
                    key: 'EQ_tmsNo',
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inbound.container_no', { defaultValue: "集装箱号" }),
                    key: 'CN_cartonNo',
                    tag: 'vTextarea',
                    class:"inboundtext",
                    props:{
                        placeholder: this.$t('fbb.inbound.input_more_line', { defaultValue: "输入多个，一行一个" }),
                        rows:"1"
                    }
                },
                {
                    label: "SKU",
                    key: 'sku',
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.transfer.istakepictures', { defaultValue: "是否拍照" }),
                    tag: "vSelect",
                    key: "EQ_hasPicture",
                    options: [
                        {
                            label: this.$t('tms.ship.correct', { defaultValue: "是" }),
                            value: 1
                        },
                        {
                            label: this.$t('tms.ship.deny', { defaultValue: "否" }),
                            value: 0
                        }
                    ],
                },
                {
                    label: this.$t('fbb.inbound.exped_warehousedate', { defaultValue: '预计入库日期' }),
                    key: 'BT_estimateArriveTime',
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: "width:361px",
                },
                {
                    label: this.$t('fbb.inbound.date_firstreceipt', { defaultValue: '首次接收日期' }),
                    key: 'BT_firstReceptionDate',
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: "width:361px",
                },
                {
                    label: this.$t('fbb.inbound.expect_arrivaldate', { defaultValue: '期望到货日期' }),
                    key: 'BT_expectArriveDate',
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: "width:361px",
                },
                {
                    label: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'BT_updatedAt',
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: "width:361px",
                },
                {
                    label: this.$t('fbb.inbound.expect_deliverydate', { defaultValue: '预计发货日期' }),
                    key: 'BT_predictionShipDate',
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: "width:361px",
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: this.$t('fbb.inbound.storage_number', { defaultValue: '入库计划单号' })+'/'+this.$t('global.common.source_number', { defaultValue: '来源单号' }),
                    render: (h, { row }) => {
                        return <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.inboundPlanOrderNo || '--'}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            <br />
                            {row.sourceNo || '--'}
                            <br />
                            <div><span style="color:red;">{this.findRenderLabel(this.getAbnormalType, row.errorStatus)} </span> </div>
                        </div>
                    }
                }, {
                    title: this.$t('erp.channelbase.area', { defaultValue: "区域" }) + "/" + this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'orgWarehouseCode',
                    render: (h, { row }) => {
                        if (row.areaId) {
                            let areaName = this.areaList.filter(item => {
                                return item.value == row.areaId;
                            })[0].label || '';
                            return <div>{areaName}{row.orgWarehouseCode ? "/" + row.orgWarehouseCode : ""}</div>
                        }
                        return <div>
                            <div>{row.orgWarehouseCode || "--"}</div>
                        </div>
                    }
                }, {
                    title: this.$t('global.common.line', { defaultValue: '项目' })+'/'+this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    key: 'lineName',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.lineName || '--'}</div>
                            <div>{this.findRenderLabel(this.getInventoryType, row.inventoryType)}</div>
                        </div>
                    }
                }, {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'inboundPlanOrderStatus',
                    render: (h, { row }) => {
                        const status = row.inboundPlanOrderStatus;
                        const { theme = 'default', label } = this.getBillStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{label}</vButton>
                    }
                }, {
                    title: 'Shipment ID/Reference ID',
                    key: 'shipmentId',
                    render: (h, { row }) => {
                        return <div>
                            {row.shipmentId || '--'}
                            <br />
                            {row.referenceId || '--'}
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.inbound.exped_warehousedate', { defaultValue: '预计入库日期' })+'/'+this.$t('fbb.inbound.date_firstreceipt', { defaultValue: '首次接收日期' }),
                    key: 'estimateArriveTime',
                    render: (h, { row }) => {
                        return <div>
                            {row.estimateArriveTime || '--'}
                            <br />
                            {`${row.firstReceptionDate || '--'}`.slice(0, 10)}
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.inbound.plan_no', { defaultValue: '计划数量/接收数量' }),
                    render: (h, { row }) => {
                        if(row.needBox == 1){
                            return <div>
                                <div>{row.packedQty || '--'}</div>
                                <div>{row.receivedQty || '--'}</div>
                            </div>
                        }else{
                            return <div>
                                <div>{row.planQty || '--'}</div>
                                <div>{row.receivedQty || '--'}</div>
                            </div>
                        }
                    }
                },
                // {
                //     title: this.$t('global.common.error_code', { defaultValue: '异常类型' })+'/'+this.$t('fbb.inbound.error_message', { defaultValue: '异常信息' }),
                //     key: 'errorStatus',
                //     render: (h, { row }) => {
                //         return <div>
                //         <div>{this.findRenderLabel(this.getAbnormalType, row.errorStatus)}</div>
                //         <div>{row.errorMessage}</div>
                //         </div>
                //     }
                // },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    sortable:true,
                }];
        },
    },
};




